export default class FlightLegs {
  arrivalAirport = ''
  departureAirport = ''
  sta = ''
  staUtc = ''
  std = ''
  stdUtc = ''
}
